import Modal from '../ui/Modal';
import Button from '../ui/Button';

const STATUS_LABELS = {
  1: { verb: 'Inhabilitar', tone: 'rose' },
  99: { verb: 'Habilitar', tone: 'emerald' },
};

const TONE_CLASSES = {
  rose: 'border-rose-300/30 bg-rose-300/[0.06] text-rose-100',
  emerald: 'border-emerald-300/30 bg-emerald-300/[0.06] text-emerald-100',
};

function ConfirmarToggleModal({
  isOpen,
  onClose,
  onConfirm,
  item,
  itemStatus,
  entityName = 'presupuesto',
  itemLabel,
  isSubmitting,
}) {
  if (!item) return null;

  const config = STATUS_LABELS[itemStatus] ?? STATUS_LABELS[1];

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`¿${config.verb} el ${entityName}?`}
      description="Confirma la acción para continuar"
      size="md"
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={isSubmitting}>
            Cancelar
          </Button>
          <Button onClick={onConfirm} isLoading={isSubmitting}>
            {isSubmitting ? 'Procesando…' : `Sí, ${config.verb.toLowerCase()}`}
          </Button>
        </>
      }
    >
      <div
        className={`rounded-2xl border px-4 py-3 text-sm animate-fade-up ${TONE_CLASSES[config.tone]}`}
      >
        <p className="font-medium">{entityName} seleccionado</p>
        <p className="mt-1 text-white/90">{itemLabel}</p>
      </div>
    </Modal>
  );
}

export default ConfirmarToggleModal;